const STUDENT_ID_KEY = 'mathtutor_student_id';
const STUDENT_NAME_KEY = 'mathtutor_student_name';
const SELECTED_CHILD_KEY = 'selectedChildId';
const SELECTED_CURRICULUM_KEY = 'mathtutor_selected_curriculum';
const ONBOARDING_PREFIX = 'onboarding_';

export const storage = {
  getStudentId: (): string => {
    // First check if there's a selected child (for parent role)
    const selectedChild = localStorage.getItem(SELECTED_CHILD_KEY);
    if (selectedChild) {
      return selectedChild;
    }
    // Fall back to stored student ID or test student
    return localStorage.getItem(STUDENT_ID_KEY) || '';
  },

  setStudentId: (id: string): void => {
    localStorage.setItem(STUDENT_ID_KEY, id);
  },

  getStudentName: (): string => {
    return localStorage.getItem(STUDENT_NAME_KEY) || 'Student';
  },

  setStudentName: (name: string): void => {
    localStorage.setItem(STUDENT_NAME_KEY, name);
  },

  getSelectedChildId: (): string | null => {
    return localStorage.getItem(SELECTED_CHILD_KEY);
  },

  setSelectedChildId: (id: string | null): void => {
    if (id) {
      localStorage.setItem(SELECTED_CHILD_KEY, id);
    } else {
      localStorage.removeItem(SELECTED_CHILD_KEY);
    }
  },

  getCurriculum: (): string | null => {
    return localStorage.getItem(SELECTED_CURRICULUM_KEY);
  },

  setCurriculum: (curriculum: string | null): void => {
    if (curriculum) {
      localStorage.setItem(SELECTED_CURRICULUM_KEY, curriculum);
    } else {
      localStorage.removeItem(SELECTED_CURRICULUM_KEY);
    }
  },

  clear: (): void => {
    localStorage.removeItem(STUDENT_ID_KEY);
    localStorage.removeItem(STUDENT_NAME_KEY);
    localStorage.removeItem(SELECTED_CHILD_KEY);
    localStorage.removeItem(SELECTED_CURRICULUM_KEY);
  },

  // Onboarding tips tracking
  hasSeenTip: (tipId: string): boolean => {
    return localStorage.getItem(ONBOARDING_PREFIX + tipId) === 'true';
  },

  markTipSeen: (tipId: string): void => {
    localStorage.setItem(ONBOARDING_PREFIX + tipId, 'true');
  },
};
